export const scte = {
  scte: {
    states: {
      active: 'ACTIVE',
      failed: 'FAILED',
      stopped: 'INACTIVE',
    },
    notifications: {
      settingsChangeErrorMsg: 'Ad Insertion could not be updated',
      settingsChangeSuccessMsg: 'Ad Insertion updated',
      startErrorMsg_plural: '{{count}} ad insertions could not be started',
      startErrorMsg: '{{count}} ad insertion could not be started',
      stopErrorMsg_plural: '{{count}} ad insertions could not be stopped',
      stopErrorMsg: '{{count}} ad insertion could not be stopped',
    },
    syncTypes: {
      auto: 'Auto',
      alive: 'Alive',
      timeDescriptor: 'Time Descriptor',
      system: 'System',
    },
    settings: {
      preEventReminders: 'Pre-Event Reminders',
      msgDeltaMs: 'Message Delta',
      msgDeltaMsExplain: '100 - 10000 ms',
      synchronizationType: 'Synchronization',
      leapSeconds: 'Leap Seconds',
      leapSecondsExplain: '0 - 1000',
      timeDescriptorPeriodSecs: 'Time Descriptor Period (Seconds)',
      settings: 'Settings',
    },
    statistics: {
      rxBytes: 'RX Bytes',
      rxOKMessages: 'RX OK Messages',
      rxCorruptMessages: 'RX Corrupt Messages',
      lastStce104Msg: 'Last RX Message Time',
      lastScte104ErrorCode: 'Last SCTE104 Error Code',
      lastScte104Error: 'Last SCTE104 Error Time',
      lastErrorOpId: 'Last SCTE104 Error OpID',
      lastLeapSeconds: 'Last Leap Seconds',
    },
  },
};
